import React from 'react'
import {Box} from '@mui/material'

interface IProps {
	segments: {value: number, color: string}[]
}

// Thin stacked bar; widths animate when the data arrives.
const ProgressSegments = ({segments}: IProps) => {
	const total = segments.reduce((sum, item) => sum + item.value, 0)

	return (
		<Box sx={{display: 'flex', height: '6px', borderRadius: '3px', overflow: 'hidden', bgcolor: 'action.hover', mt: 1}}>
			{segments.map((item, index) => (
				<Box
					key={index}
					sx={{
						width: total ? `${(item.value / total) * 100}%` : 0,
						bgcolor: item.color,
						transition: 'width .6s ease',
					}}
				/>
			))}
		</Box>
	)
}

export default ProgressSegments
